export default __webpack_public_path__ + "static/media/bs.139f285d.svg";